import customersRouter from './customersRouter';

export default customersRouter;
